import { FormControl, TextField, makeStyles } from "@material-ui/core";
import React from "react";
const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: "20px 0 0",
        width: "100%",
        "& .MuiInputLabel-formControl": {
            zIndex: 1,
        },
        "& .MuiFilledInput-root": {
            backgroundColor: "#f1f1f1",
        },
    },
}));
export const AdminFormInput = (props) => {
    const classes = useStyles();
    const { children, label, onChange, required, value, name, InputProps, } = props;
    return (React.createElement(FormControl, { variant: "filled", className: classes.formControl },
        React.createElement(TextField, { name: name && name, variant: "filled", fullWidth: true, required: required && required, label: label && label, onChange: onChange && onChange, value: value && value, InputProps: InputProps && InputProps }, children)));
};
//# sourceMappingURL=AdminFormInput.js.map